import { mapState, mapGetters, mapActions } from 'vuex';
import games from '@/descriptors/games';
import Controls from '@/components/controls/Controls.vue';
import Deck from './deck/Deck.vue';
import Result from './result/Result.vue';

export default {
  name: 'GameTable',
  components: {
    Controls,
    Deck,
    Result
  },
  mounted() {
    this.startGame(games[this.GameType]);
  },
  beforeDestroy() {
    this.stopGame();
  },
  computed: {
    ...mapGetters([
      'isResult'
    ]),
    ...mapState([
      'cards'
    ])
  },
  methods: {
    ...mapActions([
      'startGame',
      'stopGame'
    ])
  },
  props: {
    GameType: {
      type: String
    }
  }
};
